import type { HTMLAttributes, ReactNode, Ref } from 'react';

export type PageShellWidth = 'default' | 'reading' | 'narrow';

export interface PageShellProps extends Omit<HTMLAttributes<HTMLDivElement>, 'className'> {
  width?: PageShellWidth;
  className?: string;
  ref?: Ref<HTMLDivElement>;
  children?: ReactNode;
}

/** Shared page container for route-level surfaces. */
export function PageShell(props: PageShellProps): ReactNode {
  const { width = 'default', className, children, ref, ...rest } = props;
  const classes = [
    'vq-page-shell',
    width !== 'default' ? `vq-page-shell--${width}` : undefined,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div {...rest} ref={ref} className={classes} data-component="PageShell">
      {children}
    </div>
  );
}
